import { render, staticRenderFns } from "./exhibition-template-choice.vue?vue&type=template&id=bd4d8b58&scoped=true&"
import script from "./exhibition-template-choice.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-choice.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-choice.vue?vue&type=style&index=0&id=bd4d8b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d8b58",
  null
  
)

export default component.exports